import { render } from "./sidebar.vue?vue&type=template&id=5f8efadf&scoped=true&ts=true"
import script from "./sidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./sidebar.vue?vue&type=script&lang=ts&setup=true"

import "./sidebar.vue?vue&type=style&index=0&id=5f8efadf&lang=css"
import "./sidebar.vue?vue&type=style&index=1&id=5f8efadf&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8efadf"],['__file',"src/layout/components/sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f8efadf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f8efadf', __exports__)) {
    console.log('reload')
    api.reload('5f8efadf', __exports__)
  }
  
  module.hot.accept("./sidebar.vue?vue&type=template&id=5f8efadf&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('5f8efadf', render)
  })

}


export default __exports__